import type { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { openStackMachineTemplatesByNameSelector } from '../openstack-machine-templates/selectors'
import type { KubeadmControlPlaneProps } from './model'

export const kaapiKubeadmControlPlanesSelector: AppSelector<KubeadmControlPlaneProps[]> =
  createSharedSelector(
    openStackMachineTemplatesByNameSelector,
    getDataSelector<DataKeys.KaapiKubeadmControlPlanes>(DataKeys.KaapiKubeadmControlPlanes),
    (templatesByName, kaapiKubeadmControlPlanes) => {
      return kaapiKubeadmControlPlanes.map((kcp) => ({
        ...kcp,
        openStackMachineTemplate: templatesByName.get(
          kcp?.spec?.machineTemplate?.infrastructureRef?.name,
        ),
      }))
    },
  )
